import { useLingui } from "@lingui/react/macro";
import { Route } from "react-router-dom";
import { ROUTES } from "@/routes_new";
import Heading from "../Heading";
import AccountForm from "./partials/AccountForm";
import AccountPlan from "./partials/Plan";
import ChangePassword from "./partials/ChangePassword";
import AllEarsTitle from "@components/AllEarsTitle";

export default function SettingsAccountView() {
  const { t } = useLingui();

  const title = t`Konto`;

  return (
    <>
      <AllEarsTitle title={title} />

      <Route
        path={ROUTES.SETTINGS_CHANGE_PASSWORD_ORGID}
        component={ChangePassword}
      />

      <Heading
        heading={title}
        description={t`Hantera ditt abonnemang och All Ears-konto`}
      />

      <div className="w-full p-4 lg:p-6 max-w-7xl flex flex-col gap-8">
        <AccountPlan />
        <AccountForm />
      </div>
    </>
  );
}
